import { render, staticRenderFns } from "./SchoolTeachersPIP.vue?vue&type=template&id=27799e3c&scoped=true&"
import script from "./SchoolTeachersPIP.vue?vue&type=script&lang=js&"
export * from "./SchoolTeachersPIP.vue?vue&type=script&lang=js&"
import style0 from "./SchoolTeachersPIP.vue?vue&type=style&index=0&id=27799e3c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27799e3c",
  null
  
)

export default component.exports